/**
 * @GENERATED from Figma node 3608:51041
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const SlackDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#ECB22E"
      d="M12.77 20.077a1.923 1.923 0 1 0 1.922-1.923H12.77zm0-5.385c0 1.063.86 1.923 1.923 1.923h5.384a1.923 1.923 0 1 0 0-3.846h-5.384a1.923 1.923 0 0 0-1.923 1.923"
    />
    <path
      fill="#E01E5A"
      d="M3.923 12.77a1.923 1.923 0 1 0 1.923 1.922V12.77zm5.385 0a1.923 1.923 0 0 0-1.923 1.922v5.385a1.923 1.923 0 1 0 3.846 0v-5.385a1.923 1.923 0 0 0-1.923-1.923"
    />
    <path
      fill="#2EB67D"
      d="M20.077 11.23a1.923 1.923 0 1 0-1.923-1.922v1.923zm-5.385 0a1.923 1.923 0 0 0 1.923-1.923V3.923a1.923 1.923 0 0 0-3.846 0v5.384c0 1.063.861 1.924 1.923 1.924"
    />
    <path
      fill="#36C5F0"
      d="M11.23 3.923a1.923 1.923 0 1 0-1.922 1.923h1.922zm0 5.385c0-1.062-.86-1.923-1.923-1.923H3.923a1.923 1.923 0 1 0 0 3.846h5.384a1.923 1.923 0 0 0 1.923-1.923"
    />
  </svg>
);
const ForwardRef = React.forwardRef(SlackDark);
export { ForwardRef as SlackDark };
